var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _rect, _circle, _circle2, _circle3, _circle4, _path57, _path58, _path59;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGuestAccBgFooter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 422,
    viewBox: "0 0 1440 422",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M292.916 353.981H174.955V332.927H292.916C298.746 332.927 303.409 337.659 303.409 343.42C303.409 349.318 298.746 353.981 292.916 353.981Z",
    fill: "#C7E4FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M235.993 352.472H174.955V334.573H235.993C240.931 334.573 244.977 338.619 244.977 343.557C244.977 348.426 240.931 352.472 235.993 352.472Z",
    fill: "#E7F3FE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M226.323 317.77H188.671V332.995H226.323V317.77Z",
    fill: "#D7ECFD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M294.699 317.77H226.117V332.995H294.699V317.77Z",
    fill: "#BBDEFB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M267.541 308.512H182.499V318.799H267.541V308.512Z",
    fill: "#E7F3FE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M304.575 308.512H238.05V318.799H304.575V308.512Z",
    fill: "#C7E4FC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M468.143 341.088H263.357L241.479 215.858C240.793 212.086 243.331 209 247.103 209H438.241C442.013 209 445.648 212.086 446.265 215.858L468.143 341.088Z",
    fill: "#BBDEFB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M472.121 341.088H267.335L245.457 215.927C244.771 212.155 247.309 209.069 251.081 209.069H442.219C445.991 209.069 449.626 212.155 450.243 215.927L472.121 341.088Z",
    fill: "#D7ECFD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M493.381 353.981H269.941C266.306 353.981 263.288 351.032 263.288 347.329V341.019H500.034V347.329C500.034 351.032 497.085 353.981 493.381 353.981Z",
    fill: "#BBDEFB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M509.635 354H310.061C306.77 354 304.163 351.051 304.163 347.348V341.038H515.533V347.348C515.533 351.051 512.927 354 509.635 354Z",
    fill: "#C7E4FC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M425.005 345.477H394.417C392.154 345.477 390.302 343.625 390.302 341.362V341.088H429.189V341.362C429.189 343.625 427.337 345.477 425.005 345.477Z",
    fill: "#E7F3FE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M375.9 215.515C376.723 215.515 377.409 214.829 377.409 214.006C377.409 213.183 376.723 212.498 375.9 212.498C375.077 212.498 374.391 213.183 374.391 214.006C374.391 214.829 375.077 215.515 375.9 215.515Z",
    fill: "#C7E4FC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M464.234 334.847H273.301L252.658 217.161H443.659L464.234 334.847Z",
    fill: "#BBDEFB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M404.43 308.1H281.051L266.855 227.037H390.234L404.43 308.1Z",
    fill: "#E7F3FE"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M391.948 236.775H268.569L266.855 227.037H390.234L391.948 236.775Z",
    fill: "#C7E4FC"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M430.491 325.108H306.426L304.3 313.107H428.365L430.491 325.108Z",
    fill: "#C7E4FC"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M338.592 297.059H285.715L276.73 245.623H329.607L338.592 297.059Z",
    fill: "#D7ECFD"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M330.636 251.521H277.759L276.73 245.623H329.607L330.636 251.521Z",
    fill: "#C7E4FC"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M392.223 276.21H339.346L333.997 245.691H386.873L392.223 276.21Z",
    fill: "#D7ECFD"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M395.926 297.059H343.05L340.1 280.53H392.977L395.926 297.059Z",
    fill: "#D7ECFD"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M387.902 251.521H335.025L333.997 245.623H386.873L387.902 251.521Z",
    fill: "#C7E4FC"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M441.122 257.693H400.521L395.103 226.968H435.704L441.122 257.693Z",
    fill: "#E7F3FE"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M277.965 233.552C278.651 232.798 278.514 231.495 277.622 230.672C276.731 229.849 275.428 229.78 274.742 230.535C274.056 231.289 274.193 232.592 275.085 233.415C276.045 234.238 277.279 234.307 277.965 233.552Z",
    fill: "#E7F3FE"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M285.235 233.552C285.921 232.798 285.784 231.495 284.892 230.672C284 229.849 282.697 229.78 282.011 230.535C281.326 231.289 281.463 232.592 282.354 233.415C283.315 234.238 284.549 234.307 285.235 233.552Z",
    fill: "#E7F3FE"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M292.504 233.552C293.19 232.798 293.053 231.495 292.161 230.672C291.27 229.849 289.967 229.78 289.281 230.535C288.595 231.289 288.732 232.592 289.624 233.415C290.584 234.238 291.819 234.307 292.504 233.552Z",
    fill: "#E7F3FE"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M432.137 257.693H409.437L409.231 256.596C408.134 250.355 412.317 245.28 418.558 245.28C424.799 245.28 430.766 250.355 431.863 256.596L432.137 257.693Z",
    fill: "#C7E4FC"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M418.901 246.72C423.085 246.72 425.897 243.291 425.211 239.107C424.456 234.924 420.479 231.495 416.295 231.495C412.112 231.495 409.3 234.924 409.986 239.107C410.671 243.291 414.649 246.72 418.901 246.72Z",
    fill: "#C7E4FC"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M447.294 292.875H406.625L401.275 262.082H441.876L447.294 292.875Z",
    fill: "#E7F3FE"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M438.31 292.875H415.609L415.404 291.778C414.306 285.537 418.49 280.462 424.731 280.462C430.972 280.462 436.938 285.537 438.036 291.778L438.31 292.875Z",
    fill: "#C7E4FC"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M425.005 281.902C429.189 281.902 432 278.473 431.315 274.29C430.56 270.106 426.582 266.677 422.399 266.677C418.215 266.677 415.404 270.106 416.089 274.29C416.844 278.473 420.822 281.902 425.005 281.902Z",
    fill: "#C7E4FC"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M549.272 354H585.19C589.705 354 593.4 350.306 593.4 345.79V298.448H549.272V354Z",
    fill: "#D7ECFD"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M544.21 354H571.918C576.433 354 580.127 350.306 580.127 345.79V298.448H536V345.79C536 350.306 539.694 354 544.21 354Z",
    fill: "#C7E4FC"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M595.657 337.786C588.2 337.786 582.111 331.697 582.111 324.24C582.111 316.783 588.2 310.694 595.657 310.694C603.115 310.694 609.203 316.783 609.203 324.24C609.135 331.834 603.115 337.786 595.657 337.786ZM595.657 316.236C591.21 316.236 587.584 319.862 587.584 324.308C587.584 328.755 591.21 332.381 595.657 332.381C600.104 332.381 603.73 328.755 603.73 324.308C603.662 319.862 600.104 316.236 595.657 316.236Z",
    fill: "#D7ECFD"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M1111 284.755L1100.37 354H1076.62L1087.16 284.755H1111Z",
    fill: "#C7E4FC"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M1087.16 284.755L1076.62 354H1038.63L1028 284.755H1087.16Z",
    fill: "#D7ECFD"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M1034.17 284.755C1029.89 274.543 1028.94 260.455 1032.2 259.114C1035.37 257.772 1041.55 264.033 1046.78 273.574C1043.95 259.412 1044.46 247.933 1048.06 247.188C1051.06 246.591 1055.35 253.747 1058.78 264.257C1060.15 250.244 1065.21 239.809 1071.21 239.809C1076.1 239.809 1080.3 246.592 1082.53 256.58C1082.88 252.256 1084.08 248.902 1085.19 248.977C1086.39 249.051 1087.16 252.927 1086.91 257.623C1086.91 258.145 1086.82 258.667 1086.82 259.114C1089.48 255.909 1092.31 254.194 1094.71 254.791C1098.65 255.685 1100.54 262.021 1099.94 270.369C1104.31 264.182 1108.17 260.455 1109.97 261.275C1112.11 262.319 1110.23 275.288 1105.68 284.829H1034.17V284.755Z",
    fill: "#BBDEFB"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M1033.57 284.755C1030.06 276.705 1029.2 269.847 1031.94 268.804C1034.6 267.76 1039.75 272.68 1044.03 280.133C1041.72 269.027 1042.15 260.008 1045.15 259.412C1047.64 258.965 1051.24 264.555 1054.07 272.754C1055.18 261.723 1059.38 253.598 1064.44 253.598C1068.47 253.598 1071.99 258.89 1073.79 266.791C1074.04 263.362 1075.07 260.754 1076.02 260.828C1077.05 260.903 1077.65 263.884 1077.47 267.611C1077.47 267.984 1077.39 268.431 1077.39 268.804C1079.62 266.269 1081.93 264.928 1083.9 265.375C1087.16 266.046 1088.79 271.04 1088.28 277.599C1091.88 272.754 1095.14 269.773 1096.59 270.443C1098.4 271.263 1096.77 277.301 1092.99 284.755H1033.57Z",
    fill: "#E7F3FE"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M1087.42 249.498C1088.28 244.803 1087.42 240.852 1085.53 240.554C1083.65 240.256 1081.33 243.834 1080.48 248.529C1079.62 253.225 1080.47 257.176 1082.36 257.474C1084.33 257.698 1086.56 254.194 1087.42 249.498Z",
    fill: "#E7F3FE"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M1055.44 258.592C1057.32 258.368 1058.1 252.778 1056.98 246.144C1055.95 239.51 1053.55 234.293 1051.58 234.516C1049.69 234.74 1048.92 240.33 1050.04 246.964C1051.06 253.598 1053.47 258.816 1055.44 258.592Z",
    fill: "#E7F3FE"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M1041.98 258.89C1043.35 258.518 1043.18 254.418 1041.55 249.573C1039.92 244.803 1037.52 241.225 1036.15 241.523C1034.77 241.896 1034.95 245.995 1036.57 250.84C1038.2 255.611 1040.6 259.188 1041.98 258.89Z",
    fill: "#BBDEFB"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M1167.3 332.218L1237.45 227.945L1232.05 224.294L1161.9 328.567L1167.3 332.218Z",
    fill: "#C7E4FC"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M1235.98 225.066L1156.63 145.72L1152 150.355L1231.41 229.701L1235.98 225.066Z",
    fill: "#C7E4FC"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M1167.3 156.534L1157.68 146.914L1153.05 151.548L1162.67 161.168L1167.3 156.534Z",
    fill: "#BBDEFB"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M1146.52 127.745L1144.91 126.13C1142.52 123.742 1142.52 119.88 1144.91 117.493L1152.21 110.19C1154.6 107.803 1158.46 107.803 1160.84 110.19L1162.46 111.805C1164.85 114.193 1164.85 118.055 1162.46 120.442L1155.16 127.745C1152.77 130.132 1148.91 130.132 1146.52 127.745Z",
    fill: "#BBDEFB"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M1128.05 144.597L1145.12 161.66L1156.91 149.863C1164.85 141.929 1164.85 129.008 1156.91 121.004L1154.24 118.335L1128.05 144.597Z",
    fill: "#E7F3FE"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M1128.05 144.597L1110.99 127.534L1122.79 115.737C1130.72 107.803 1143.64 107.803 1151.65 115.737L1154.31 118.406L1128.05 144.597Z",
    fill: "#C7E4FC"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M1192.86 338.327H1141.75V336.361C1141.75 330.603 1146.45 325.899 1152.21 325.899H1182.33C1188.09 325.899 1192.79 330.603 1192.79 336.361L1192.86 338.327Z",
    fill: "#C7E4FC"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M1217.02 353.635H1117.59V350.826C1117.59 342.4 1124.4 335.589 1132.83 335.589H1201.78C1210.21 335.589 1217.02 342.4 1217.02 350.826V353.635Z",
    fill: "#C7E4FC"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M1189.07 353.635H1117.59V350.826C1117.59 342.4 1124.4 335.589 1132.83 335.589H1173.84C1182.26 335.589 1189.07 342.4 1189.07 350.826V353.635Z",
    fill: "#E7F3FE"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M1139.85 149.933C1137.74 146.563 1135.29 143.333 1132.34 140.384C1112.39 120.442 1079.95 120.442 1060.01 140.384C1060.01 140.384 1070.97 151.267 1077.07 157.447C1094.14 140.384 1120.19 137.926 1139.85 149.933Z",
    fill: "#C7E4FC"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M1139.85 149.933C1120.19 137.926 1094.14 140.454 1077.07 157.447C1097.02 177.389 1132.34 212.708 1132.34 212.708C1149.33 195.575 1151.86 169.594 1139.85 149.933Z",
    fill: "#E7F3FE"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M1120.4 182.374C1116.61 185.674 1111.69 187.71 1106.36 187.71C1094.56 187.71 1085.01 178.161 1085.01 166.364C1085.01 160.958 1087.05 156.042 1090.35 152.321C1076.09 141.507 1063.8 136.522 1059.52 140.735C1053.69 146.563 1065.14 167.488 1085.15 187.5C1105.16 207.512 1126.09 218.957 1131.91 213.129C1136.13 208.846 1131.14 196.558 1120.4 182.374Z",
    fill: "#BBDEFB"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M1106.28 187.711C1111.69 187.711 1116.61 185.674 1120.33 182.374C1116.33 177.178 1111.62 171.701 1106.21 166.364C1100.81 161.028 1095.4 156.253 1090.2 152.251C1086.9 156.042 1084.87 160.958 1084.87 166.294C1084.94 178.161 1094.49 187.711 1106.28 187.711Z",
    fill: "#F5FAFE"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M1222.85 249.642L1236.54 229.279L1231.13 225.628L1217.44 245.991L1222.85 249.642Z",
    fill: "#BBDEFB"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M1233.66 236.722C1238.79 236.722 1243 232.579 1243 227.383C1243 222.257 1238.86 218.044 1233.66 218.044C1228.53 218.044 1224.32 222.187 1224.32 227.383C1224.32 232.579 1228.53 236.722 1233.66 236.722Z",
    fill: "#C7E4FC"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M1233.66 231.526C1235.98 231.526 1237.8 229.701 1237.8 227.383C1237.8 225.066 1235.98 223.241 1233.66 223.241C1231.34 223.241 1229.52 225.066 1229.52 227.383C1229.52 229.701 1231.34 231.526 1233.66 231.526Z",
    fill: "#D7ECFD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 354,
    width: 1440,
    height: 68,
    fill: "#E7F3FE"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 480.732,
    cy: 157.804,
    r: 5.76289,
    fill: "#D7ECFD"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1188.24,
    cy: 140.072,
    r: 5.76289,
    fill: "#D7ECFD"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1085.39,
    cy: 21.268,
    r: 5.76289,
    fill: "#D7ECFD"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 669.763,
    cy: 282.763,
    r: 5.76289,
    fill: "#D7ECFD"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M378.785 107.571L383.882 122.057L368.788 119.228L378.785 107.571Z",
    fill: "#D7ECFD"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M486.063 2.06629L491.16 16.5521L476.067 13.7232L486.063 2.06629Z",
    fill: "#D7ECFD"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M1027.9 75.4779L1021.91 89.6204L1012.66 77.367L1027.9 75.4779Z",
    fill: "#D7ECFD"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuestAccBgFooter);
export default __webpack_public_path__ + "static/media/guest_acc_bg_footer.1c62dd5e.svg";
export { ForwardRef as ReactComponent };